import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteGoal,
  fetchGoals,
} from '../../../store/landscapeAPI/goal/reducers/goal.slice';

import { AppDispatch, RootState } from '../../../store/store';
import Spinner from '../../atoms/Spinner/Spinner';
import { ReportingDetailsGoalsTemplate } from '../../templates';
import styles from './ReportingDetailsGoalsPage.module.css';
import cn from 'classnames';

interface ReportingDetailsGoalsPageProps {}

const ReportingDetailsGoalsPage: FC<ReportingDetailsGoalsPageProps> = () => {
  const { goals, status } = useSelector((state: RootState) => state.goalSlice);

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchGoals());
  }, [dispatch]);

  const handleDeleteGoal = (id: string) => {
    dispatch(deleteGoal(id));
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <div className={cn(styles.wrapper)}>
      <ReportingDetailsGoalsTemplate
        data={goals ?? []}
        handleDeleteGoal={handleDeleteGoal}
      />
    </div>
  );
};

export default ReportingDetailsGoalsPage;
